<!-- <p>date-time-picker works!</p> -->
<div #DateTimePicker [ngStyle]="fixedDimensions" class="date-time-wrapper">
  <mat-card class="dt-picker-card">
    <mat-card-header
      [ngClass]="{
        'dt-picker-card-header':
          screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
        'dt-picker-card-header-mobile': screenInfo == ScreenType.Mobile
      }"
      >Please select Date and Time</mat-card-header
    >
    <mat-card-content class="dt-picker-card-content"
      ><mat-stepper #stepper linear class="dt-picker-stepper">
        <mat-step class="dt-picker-stepper-step">
          <app-calendar-picker
            (calendarDimensions)="getCalendarDimensions($event)"
            (selectedDate)="getSelectedDate($event)"
          ></app-calendar-picker>
        </mat-step>
        <mat-step class="dt-picker-stepper-step">
          <app-time-picker
            [calDimensions]="calendarHeight"
            [selectedDate]="selectDate"
            (selectedDateTimeSlot)="getDateTimeSlot($event)"
            [screen]="screenInfo"
          ></app-time-picker>
        </mat-step> </mat-stepper
    ></mat-card-content>
  </mat-card>
  <div class="dt-picker-card-actions">
    <button
      *ngIf="stepper.selectedIndex != 0"
      (click)="goBack(stepper)"
      mat-button
    >
      Cancel
    </button>
    <button
      [disabled]="temp1 < temp2"
      *ngIf="stepper.selectedIndex != 1"
      (click)="goNext(stepper)"
      mat-button
    >
      Select Time
    </button>
    <button
      [disabled]="!isTimeSlotSelected"
      *ngIf="stepper.selectedIndex != 0"
      (click)="onAddNewVisitor()"
      mat-button
    >
      Add Visitor
    </button>
  </div>
</div>
